// Common validation messages
export const VALIDATION_MESSAGES = {
  REQUIRED: {
    DRIVER_ID: "Pengemudi tidak boleh kosong",
    VEHICLE_ID: "Nomor kendaraan tidak boleh kosong",
    DELIVERY_DATE: "Tanggal pengambilan barang tidak boleh kosong",
    SHIPPING_WINDOW: "Shipping window tidak boleh kosong",
    DESTINATION: "Tujuan tidak boleh kosong",
    ACTIVITY_TYPE: "Jenis aktivitas tidak boleh kosong",
    ACTIVITY_SUBTYPE: "Tipe transit tidak boleh kosong",
    NOTES: "Catatan tidak boleh kosong",
    VEHICLE_TYPE: "Tipe kendaraan tidak boleh kosong",
    LICENSE_PLATE_PREFIX: "Kode wilayah plat tidak boleh kosong",
    LICENSE_PLATE_NUMBER: "Nomor plat tidak boleh kosong",
    LICENSE_PLATE_SUFFIX: "Kode akhir plat tidak boleh kosong",
    ATTACHMENT: "Minimal 1 file harus diupload",
    CONDITION: "Minimal 1 kondisi harus dipilih",
    TRANSIT_TYPE: "Tipe transit tidak boleh kosong",
    NAME: "Nama pengemudi tidak boleh kosong",
  },
  LENGTH: {
    NOTES_MAX: "Catatan maksimal 50 karakter",
    KIR_NUMBER_MAX: "Nomor KIR maksimal 20 karakter",
    USERNAME_MIN: "Username minimal harus 4 karakter",
    PASSWORD_MIN: "Password minimal harus 6 karakter",
    PASSWORD_MAX: "Password tidak boleh lebih dari 20 karakter",
    LICENSE_PLATE_PREFIX_MIN: "Kode wilayah plat minimal 1 karakter",
    LICENSE_PLATE_PREFIX_MAX: "Kode wilayah plat maksimal 2 karakter",
    LICENSE_PLATE_NUMBER_MIN: "Nomor plat minimal 1 digit",
    LICENSE_PLATE_NUMBER_MAX: "Nomor plat maksimal 4 digit",
    LICENSE_PLATE_SUFFIX_MIN: "Kode akhir plat minimal 1 karakter",
    LICENSE_PLATE_SUFFIX_MAX: "Kode akhir plat maksimal 3 karakter",
    ATTACHMENT_MAX: "Maksimal upload 3 file",
    KTP_NUMBER_MAX: "Nomor KTP maksimal 20 karakter",
    SIM_NUMBER_MAX: "Nomor SIM maksimal 20 karakter",
    PHONE_MAX: "Nomor handphone maksimal 15 karakter",
  },
  FORMAT: {
    USERNAME_NO_SPACES: "Username tidak boleh mengandung spasi",
    USERNAME_PATTERN: "Username hanya boleh mengandung huruf, angka, underscore, dan titik",
    PASSWORD_COMPLEXITY:
      "Password harus mengandung minimal satu huruf, satu angka dan satu karakter spesial",
    LICENSE_PLATE_PREFIX_CAPS: "Kode wilayah plat harus huruf kapital",
    LICENSE_PLATE_NUMBER_NUMERIC: "Nomor plat harus berupa angka",
    LICENSE_PLATE_SUFFIX_CAPS: "Kode akhir plat harus huruf kapital",
    PHONE_NUMBER: "Nomor handphone tidak sesuai format (8xxxxxxxxxx)",
    KTP_NUMBER_NUMERIC: "Nomor KTP harus berupa angka",
    SIM_NUMBER_NUMERIC: "Nomor SIM harus berupa angka",
  },
} as const;

// Common regex patterns
export const REGEX_PATTERNS = {
  NO_SPACES: /^\S+$/,
  USERNAME_PATTERN: /^[a-zA-Z0-9_.]+$/,
  PASSWORD_COMPLEXITY: new RegExp(
    "^(?=.*[a-zA-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,}$"
  ),
  UPPERCASE_LETTERS: /^[A-Z]+$/,
  NUMERIC_ONLY: /^\d+$/,
  PHONE_NUMBER: /^8[1-9]\d*$/,
} as const;

// Common validation limits
export const VALIDATION_LIMITS = {
  USERNAME_MIN_LENGTH: 4,
  PASSWORD_MIN_LENGTH: 6,
  PASSWORD_MAX_LENGTH: 20,
  NOTES_MAX_LENGTH: 50,
  KIR_NUMBER_MAX_LENGTH: 20,
  LICENSE_PLATE_PREFIX_MIN_LENGTH: 1,
  LICENSE_PLATE_PREFIX_MAX_LENGTH: 2,
  LICENSE_PLATE_NUMBER_MIN_LENGTH: 1,
  LICENSE_PLATE_NUMBER_MAX_LENGTH: 4,
  LICENSE_PLATE_SUFFIX_MIN_LENGTH: 1,
  LICENSE_PLATE_SUFFIX_MAX_LENGTH: 3,
  ATTACHMENT_MAX: 3,
  KTP_NUMBER_MAX_LENGTH: 20,
  SIM_NUMBER_MAX_LENGTH: 20,
  PHONE_MAX_LENGTH: 15,
} as const;
